
import { TokenRefresh } from '@/components/ApiRoutes';
import axios from 'axios';
import {
  QueryClient,
} from '@tanstack/react-query'

import { toast } from 'sonner';

const apiClient = axios.create({
    baseURL: 'https://api.mediaharbor.app/api/',
    //baseURL: 'http://127.0.0.1:8000/api/', for testing
});

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 5
        }
    }
});


apiClient.interceptors.request.use(
    // pre appends access token to every request
    // if a user is not logged in and trying to access a non auth page, it wont matter
    (config) => {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            config.headers['Authorization'] = `Bearer ${accessToken}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// catch and handle errors
apiClient.interceptors.response.use(
    // if response is successful, just return it
    (response) => {
        return response;
    },
   async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            return new Promise((resolve, reject) => {
                TokenRefresh().then(async () => {
                    const newTokens = {
                        access: localStorage.getItem('accessToken'),
                        refresh: localStorage.getItem('refreshToken'),
                    };
                    originalRequest.headers['Authorization'] = `Bearer ${newTokens.access}`;
                    
                    try {
                        const response = await apiClient(originalRequest);
                        resolve(response);
                    } catch (retryError) {
                        reject(retryError);
                    }

                }).catch((refreshError) => {
                    toast.error("Authentication refresh failed. Please log-in again.");
                    localStorage.removeItem('accessToken');
                    localStorage.removeItem('refreshToken');
                    localStorage.removeItem("username");
                    localStorage.removeItem("profile");
                    localStorage.removeItem("avatar");

                   
                    reject(refreshError);
                });
            });
        }

        return Promise.reject(error);
    }
);

export default apiClient;